import { get, patch, post } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    inhabitants: []
  },

  getters: {},

  mutations: {},

  actions: {
    getInhabitant: (_, inhabitant) => get(`/inhabitants/${inhabitant}`),
    getCohabitants: (_, inhabitant) =>
      get(`/inhabitants/${inhabitant}/cohabitants`),

    store: (_, inhabitant) => post('/inhabitants', inhabitant),

    update: (_, inhabitant) =>
      patch(`/inhabitants/${inhabitant.id}`, inhabitant),

    checkOut: (_, { id, data }) => patch(`/inhabitants/${id}/check-out`, data)
  }
};
